import { WixDesignSystemProvider } from '@wix/design-system';
import React, { useContext } from 'react';

type UiComponentsContextProps = {
  containerEl: HTMLDivElement;
  children: React.ReactNode;
};

export const UiComponentsContext = React.createContext(null as unknown as HTMLDivElement);

export const UiComponentsProvider: React.FC<UiComponentsContextProps> = ({
  children,
  containerEl,
}) => {
  return (
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
      <UiComponentsContext.Provider value={containerEl}>{children}</UiComponentsContext.Provider>
    </WixDesignSystemProvider>
  );
};

export const usePanelContainerElement = () => useContext(UiComponentsContext);
